module.exports = __webpack_public_path__ + "static/assets/991c3ebc9dc81cc4649e5c14842c95ac.svg";